export const download = (url, filename) => {
  const link = document.createElement('a')
  link.setAttribute('download', filename)
  link.setAttribute('href', url)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Generate a URL from a Blob object and trigger download
 * @param {Blob|File} object Object to download
 * @param {string} filename name to the downloaded file
 */
export const downloadObject = (object, filename) => {
  const url = URL.createObjectURL(object)

  download(url, filename)
  URL.revokeObjectURL(url)
}
